import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import './assets/main.css'; // Import global styles

const app = createApp(App);

app.use(createPinia()); // Use Pinia for state management
app.mount('#app');